import React from 'react';
import { FieldDisplayProps } from '../../types';

// Color palette for select options
const TAG_COLORS = [
  { bg: '#dbeafe', text: '#1e40af' }, // Blue
  { bg: '#dcfce7', text: '#166534' }, // Green
  { bg: '#fef3c7', text: '#92400e' }, // Yellow
  { bg: '#fce7f3', text: '#9d174d' }, // Pink
  { bg: '#e0e7ff', text: '#3730a3' }, // Indigo
  { bg: '#fed7d7', text: '#9b2c2c' }, // Red
  { bg: '#d1fae5', text: '#065f46' }, // Teal
  { bg: '#fef9c3', text: '#854d0e' }, // Amber
  { bg: '#ede9fe', text: '#5b21b6' }, // Purple
  { bg: '#cffafe', text: '#155e75' }, // Cyan
];

const getTagColor = (value: string, options?: string[]) => {
  const index = options?.indexOf(value) ?? 0;
  return TAG_COLORS[Math.abs(index) % TAG_COLORS.length];
};

export const SelectFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  fieldDefinition,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  const options = 'options' in fieldDefinition ? fieldDefinition.options : [];
  const color = getTagColor(value, options);

  return (
    <div
      className="pill custom-field-pill editable"
      style={{
        backgroundColor: color.bg,
        color: color.text,
      }}
      onDoubleClick={handleClick}
      onClick={handleClick}
    >
      {value}
    </div>
  );
};

export default SelectFieldDisplay;
